import { toZonedTime as utcToZonedTimeFns, fromZonedTime as zonedTimeToUtcFns } from 'date-fns-tz'
import { DEFAULT_TIME_ZONE, PREFERRED_TIME_ZONE } from 'store/store'

import { TimeZones } from './TimeZones'
import { TimeZone } from './types'

export const getTimeZones = (): TimeZone[] => {
  return TimeZones
}

export const getTimeZoneById = (id: string): string => {
  return TimeZones.find((timeZone) => timeZone.id === id)?.name || DEFAULT_TIME_ZONE
}

export const getTimeZoneId = (): string => {
  const name = getTimeZone()

  return TimeZones.find((timeZone) => timeZone.name === name)?.id || DEFAULT_TIME_ZONE
}

export const utcToZonedTime = (date: Date | string): Date => {
  const timeZone = getTimeZone()

  return utcToZonedTimeFns(date, timeZone)
}

export const zonedTimeToUtc = (date: Date | string, useDefaultTimeZone?: boolean): Date => {
  const timeZone: string = useDefaultTimeZone ? DEFAULT_TIME_ZONE : getTimeZone()

  return zonedTimeToUtcFns(date, timeZone)
}

export const rawDateString = (date: string | Date): string => {
  if (date instanceof Date) {
    return date.toISOString().slice(0, 10)
  }

  return date.slice(0, 10)
}

const getTimeZone = (): string => localStorage.getItem(PREFERRED_TIME_ZONE) || DEFAULT_TIME_ZONE
